import React, { FC } from 'react';
import { PieChart as DefaultPieChart, Cell, Pie } from 'recharts';
import formatPriceNumber from 'utils/formatPrice';
import { Props } from './types';
import {
  Container,
  DataContainer,
  Data,
  NameContainer,
  Name,
  Amount,
  ColoredDot,
} from './styles';

const PieChart: FC<Props> = ({ data }) => {
  const COLORS = ['#FF7664', '#3DC694', '#FFAD4F', '#754A89', '#498DF2'];

  return (
    <Container>
      <DefaultPieChart width={200} height={200}>
        <Pie
          data={data}
          dataKey="totalSales"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={100}
          paddingAngle={0}
          blendStroke
        >
          {data.map((item, index) => (
            <Cell key={item.name} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </DefaultPieChart>
      <DataContainer>
        {data.map((item, index) => (
          <Data key={item.name}>
            <NameContainer>
              <ColoredDot color={COLORS[index % COLORS.length]} />
              <Name>{item.name}</Name>
            </NameContainer>
            <Amount>{formatPriceNumber(item.totalSales)}</Amount>
          </Data>
        ))}
      </DataContainer>
    </Container>
  );
};

export default PieChart;
